import qs from 'qs'
import {filterUndefined} from '../utils'
export default function filterParams(config) {
  let params = Object.assign({}, config.params)
  // 将url上带的参数转换成params，方便做签名 & 增加跨域参数
  const index = config.url.indexOf('?')
  if (index > -1) {
    let search = config.url.slice(index + 1)
    config.url = config.url.slice(0, index)
    search && Object.assign(params, qs.parse(search))
  }
  // 过滤undefined和null
  config.params = filterUndefined(params)
  return config
}
